/** Тексты пространства «ui». Ключи именуются по смыслу, а не по месту. */
export const ui = {
  /** Три состояния экрана: ждём, не вышло, сюда нельзя. */
  state: {
    loading: 'Загружаем',
    error: 'Не получилось загрузить',
    noAccess: {
      title: 'Раздел закрыт',
      text: 'Этот раздел виден только сотрудникам проекта.',
    },
  },

  /** Кадр: заглушка без снимка и просмотр на весь экран. */
  thumb: {
    empty: 'без фото',
    open: 'Открыть фото',
    openNamed: 'Открыть фото: {{alt}}',
  },

  photo: {
    title: 'Фотография',
    close: 'Закрыть',
    prev: 'Предыдущая',
    next: 'Следующая',
    count: '{{current}} из {{total}}',
  },

  /** Шапка карточки персонажа. */
  hero: {
    appearanceAlt: 'Внешность: {{title}}',
  },

  /** Подпись поля формы. */
  field: {
    required: 'обязательно',
    hint: 'Пояснение к полю',
  },

  /** Поле «фото»: выбор, замена и снятие снимка. */
  image: {
    pick: 'Выбрать фото',
    replace: 'Заменить',
    remove: 'Убрать',
  },

  /** Длинный текст, свёрнутый до трёх строк. */
  readMore: {
    expand: 'читать всё',
    collapse: 'свернуть',
  },

  /** Чип фильтра: читалке называет и группу, и выбранное. */
  filter: {
    value: '{{group}}: {{value}}',
  },

  /** Метка предмета. */
  chip: {
    remove: 'Снять метку: {{name}}',
  },

  /** Возврат обведённым квадратом. */
  back: 'Назад',
} as const;
